<template>
  <!-- lang button -->
  <v-btn
    text
    @click="
      $i18n.locale === app.GLOBAL.LANG.EN
        ? chgLocate(app.GLOBAL.LANG.ZH)
        : $i18n.locale === app.GLOBAL.LANG.ZH
        ? chgLocate(app.GLOBAL.LANG.EN)
        : null
    "
  >
    <span :title="$t('common.title_language')">{{
      $i18n.locale === app.GLOBAL.LANG.EN
        ? $t("common.zh")
        : $i18n.locale === app.GLOBAL.LANG.ZH
        ? $t("common.en")
        : null
    }}</span>
  </v-btn>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["app"],
  methods: {
    chgLocate(val) {
      // const old_val = this.locate;
      this.app.locate = val;
      this.$i18n.locale = val;
      window.localStorage.setItem(this.app.GLOBAL.LOCALE_KEY, val);
      // console.log(old_val)
      // document.body.classList.remove(`lang-${old_val}`);

      // document.body.classList.add(`lang-${val}`);
      // document.body.setAttribute("lang", val);
    },
  },
};
</script>
